import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize } = theme.tokens;
  const stickyTop = theme.layout.headerHeight + 20;

  return {
    root: {
      display: "flex",
      flexWrap: "wrap",
      gap: 40,
      alignItems: "flex-start",
      minWidth: 0
    },
    nav: {
      flex: "0 1 240px",
      minWidth: 220,
      display: "flex",
      flexDirection: "column",
      gap: 2,
      position: "sticky",
      top: stickyTop,
      maxHeight: `calc(100vh - ${stickyTop + 24}px)`,
      overflowY: "auto",
      [theme.media.belowDesktop]: { display: "none" }
    },
    navItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      padding: "10px 14px",
      borderRadius: radius.field,
      fontSize: fontSize.body,
      fontWeight: 500,
      color: color.ink,
      textDecoration: "none",
      "&:hover": { backgroundColor: color.surface, color: color.ink }
    },
    navCount: {
      fontSize: fontSize.small,
      color: color.muted
    },
    sections: {
      flex: "999 1 560px",
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      gap: theme.layout.sectionGap
    },
    section: {
      display: "flex",
      flexDirection: "column",
      gap: theme.layout.titleGap
    },
    sectionHead: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      gap: 16
    },
    sectionTitles: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      minWidth: 0
    },
    sectionTitle: {
      margin: 0,
      fontSize: fontSize.h2,
      fontWeight: 800,
      letterSpacing: "-0.01em",
      color: color.ink,
      [theme.media.phone]: { fontSize: fontSize.mobile.h2 }
    },
    sectionBlurb: {
      fontSize: fontSize.small,
      color: color.muted
    },
    seeAll: {
      fontSize: fontSize.body,
      fontWeight: 700,
      color: color.ink,
      padding: "0 4px",
      whiteSpace: "nowrap",
      textDecoration: "none",
      "&:hover": { color: color.brandText }
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(132px, 1fr))",
      gap: "20px 16px",
      [theme.media.phone]: {
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "16px 10px"
      }
    },
    sub: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      color: color.ink,
      textDecoration: "none",
      "&:hover": { color: color.ink }
    },
    subTile: {
      aspectRatio: "1 / 1",
      borderRadius: radius.tile,
      backgroundColor: color.surface,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      transition: "background-color .15s"
    },
    subImage: {
      width: "76%",
      height: "76%",
      objectFit: "contain",
      mixBlendMode: "multiply",
      transition: "transform .25s ease"
    },
    subName: {
      fontSize: fontSize.ui,
      fontWeight: 600,
      lineHeight: 1.3,
      transition: "color .15s ease"
    },
    skeletonTile: {
      aspectRatio: "1 / 1",
      height: "auto !important",
      minHeight: 100,
      borderRadius: `${radius.tile}px !important`
    },
    // hover effects go last: JSS resolves $refs only to classes defined above
    [theme.media.hover]: {
      sub: {
        "&:hover $subTile": { backgroundColor: color.surfaceHover },
        "&:hover $subImage": { transform: "scale(1.05)" },
        "&:hover $subName": { color: color.brandText }
      }
    }
  };
});

export default withCustomStyles;
